// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "kolibri.core.default_frontend-" + chunkId + "-0.20.0a1.js";
};